import { createClient } from '@supabase/supabase-js';

// Build-time env (preferred in Vite)
const envSupabaseUrl = import.meta.env.VITE_SUPABASE_URL as string | undefined;
const envSupabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY as string | undefined;

// Runtime fallback via URL params for hosting where envs weren’t injected.
// Example: https://your-app.vercel.app/?supabaseUrl=...&supabaseKey=...
let runtimeSupabaseUrl: string | undefined;
let runtimeSupabaseAnonKey: string | undefined;
if (typeof window !== 'undefined') {
  try {
    const params = new URLSearchParams(window.location.search);
    const url = params.get('supabaseUrl') || undefined;
    const key = params.get('supabaseKey') || undefined;
    runtimeSupabaseUrl = url;
    runtimeSupabaseAnonKey = key;
  } catch (e) {
    // ignore
  }
}

const supabaseUrl = envSupabaseUrl || runtimeSupabaseUrl;
const supabaseAnonKey = envSupabaseAnonKey || runtimeSupabaseAnonKey;

console.log('Supabase configuration:', {
  hasEnvUrl: !!envSupabaseUrl,
  hasEnvKey: !!envSupabaseAnonKey,
  hasRuntimeUrl: !!runtimeSupabaseUrl,
  hasRuntimeKey: !!runtimeSupabaseAnonKey,
  effectiveUrl: !!supabaseUrl,
  effectiveKey: !!supabaseAnonKey,
  keyLength: supabaseAnonKey?.length || 0
});
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.error('Missing Supabase environment variables:', {
    VITE_SUPABASE_URL: !!supabaseUrl,
    VITE_SUPABASE_ANON_KEY: !!supabaseAnonKey
  });
}

// Create a client only when configured; otherwise create a harmless placeholder client
// to avoid crashing the app during import. Calls will fail gracefully and be caught in hooks.
export const supabase = createClient(
  (supabaseUrl as string) || 'https://invalid.supabase.co',
  (supabaseAnonKey as string) || 'invalid-anon-key'
);

// Test the connection only when configured
if (isSupabaseConfigured) {
  supabase
    .from('rooms')
    .select('count', { count: 'exact', head: true })
    .then(({ error, count }) => {
      if (error) {
        console.error('Supabase connection test failed:', error);
      } else {
        console.log('Supabase connection successful. Total rooms:', count);
      }
    });
}

// Database types
export interface DatabaseRoom {
  id: string;
  number: string;
  is_expanded: boolean;
  building_type?: string;
  created_at: string;
}

export interface DatabaseResident {
  id: string;
  room_id: string;
  name: string;
  phone: string;
  study: string;
  position: 1 | 2;
  payment_pattern: number;
  start_date: string | null;
  date_of_birth?: string | null;
  next_payment_date: string | null;
  created_at: string;
}

export interface DatabasePaymentPeriod {
  id: string;
  resident_id: string;
  period_number: number;
  dp_date: string | null;
  start_date: string | null;
  payment_proof_date: string | null;
  payment_proof_link: string;
  next_payment_date: string | null;
  created_at: string;
  category?: 'DP' | 'Pelunasan' | 'Cicilan' | null;
  installment_number?: number | null;
}
 
